/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 3LBYSAoY9tVV

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomeProductsSectionQuote.module.css"; // plasmic-import: 3LBYSAoY9tVV/css

import Icon67Icon from "./icons/PlasmicIcon__Icon67"; // plasmic-import: JqWEyuKSyfsl/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicHomeProductsSectionQuote__VariantMembers = {};
export type PlasmicHomeProductsSectionQuote__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeProductsSectionQuote__VariantsArgs;
export const PlasmicHomeProductsSectionQuote__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeProductsSectionQuote__ArgsType = {};
type ArgPropType = keyof PlasmicHomeProductsSectionQuote__ArgsType;
export const PlasmicHomeProductsSectionQuote__ArgProps =
  new Array<ArgPropType>();

export type PlasmicHomeProductsSectionQuote__OverridesType = {
  quote?: Flex__<"div">;
  top?: Flex__<"div">;
  header?: Flex__<"div">;
  quoteLogo?: Flex__<"div">;
  mercyHealthLogo?: Flex__<typeof PlasmicImg__>;
  svg?: Flex__<"svg">;
  title4?: Flex__<"p">;
  author?: Flex__<"div">;
  av?: Flex__<"div">;
  name?: Flex__<"p">;
  button4?: Flex__<typeof Button>;
  text?: Flex__<"div">;
};

export interface DefaultHomeProductsSectionQuoteProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeProductsSectionQuote__RenderFunc(props: {
  variants: PlasmicHomeProductsSectionQuote__VariantsArgs;
  args: PlasmicHomeProductsSectionQuote__ArgsType;
  overrides: PlasmicHomeProductsSectionQuote__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"quote"}
      data-plasmic-override={overrides.quote}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.quote
      )}
    >
      <div
        data-plasmic-name={"top"}
        data-plasmic-override={overrides.top}
        className={classNames("all", sty.top)}
      >
        <div
          data-plasmic-name={"header"}
          data-plasmic-override={overrides.header}
          className={classNames("all", sty.header)}
        >
          <div
            data-plasmic-name={"quoteLogo"}
            data-plasmic-override={overrides.quoteLogo}
            className={classNames("all", sty.quoteLogo)}
          >
            <PlasmicImg__
              data-plasmic-name={"mercyHealthLogo"}
              data-plasmic-override={overrides.mercyHealthLogo}
              alt={"Mercy Health Logo"}
              aria-label={"Mercy Health Logo"}
              className={classNames(sty.mercyHealthLogo)}
              displayHeight={"156.25%"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"156.25%"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://img.plasmic.app/img-optimizer/v1/img/b3b7fca895f45ecb1419ed53a90cc23f.png",
                fullWidth: 800,
                fullHeight: 400
              }}
            />
          </div>
          <Icon67Icon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames("all", sty.svg)}
            role={"img"}
          />
        </div>
        <p
          data-plasmic-name={"title4"}
          data-plasmic-override={overrides.title4}
          className={classNames(
            "all",
            "p",
            "p__bvRZj",
            "__wab_text",
            sty.title4
          )}
        >
          {
            "MyEvaluations offers a complete residency management software package. The software package is complex, and Dr Melamed and his team go above and beyond in assisting customers in the proper use of the functionality of the software..."
          }
        </p>
      </div>
      <div
        data-plasmic-name={"author"}
        data-plasmic-override={overrides.author}
        className={classNames("all", sty.author)}
      >
        <div
          data-plasmic-name={"av"}
          data-plasmic-override={overrides.av}
          aria-label={
            hasVariant(globalVariants, "mobile", "tabletLandscape")
              ? ``
              : undefined
          }
          className={classNames("all", sty.av)}
        />

        <p
          data-plasmic-name={"name"}
          data-plasmic-override={overrides.name}
          className={classNames("all", "p", "p__bvRZj", "__wab_text", sty.name)}
        >
          {
            "Joseph J Sreenan, MD, DIO Mercy Health St. Rita\u2019s in Lima, Ohio"
          }
        </p>
      </div>
      {false ? (
        <Button
          data-plasmic-name={"button4"}
          data-plasmic-override={overrides.button4}
          className={classNames("__wab_instance", sty.button4)}
          color={"white"}
          size={"medium"}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames("all", "__wab_text", sty.text)}
          >
            {"READ MORE"}
          </div>
        </Button>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  quote: [
    "quote",
    "top",
    "header",
    "quoteLogo",
    "mercyHealthLogo",
    "svg",
    "title4",
    "author",
    "av",
    "name",
    "button4",
    "text"
  ],
  top: ["top", "header", "quoteLogo", "mercyHealthLogo", "svg", "title4"],
  header: ["header", "quoteLogo", "mercyHealthLogo", "svg"],
  quoteLogo: ["quoteLogo", "mercyHealthLogo"],
  mercyHealthLogo: ["mercyHealthLogo"],
  svg: ["svg"],
  title4: ["title4"],
  author: ["author", "av", "name"],
  av: ["av"],
  name: ["name"],
  button4: ["button4", "text"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  quote: "div";
  top: "div";
  header: "div";
  quoteLogo: "div";
  mercyHealthLogo: typeof PlasmicImg__;
  svg: "svg";
  title4: "p";
  author: "div";
  av: "div";
  name: "p";
  button4: typeof Button;
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeProductsSectionQuote__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeProductsSectionQuote__VariantsArgs;
    args?: PlasmicHomeProductsSectionQuote__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeProductsSectionQuote__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeProductsSectionQuote__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeProductsSectionQuote__ArgProps,
          internalVariantPropNames:
            PlasmicHomeProductsSectionQuote__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeProductsSectionQuote__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "quote") {
    func.displayName = "PlasmicHomeProductsSectionQuote";
  } else {
    func.displayName = `PlasmicHomeProductsSectionQuote.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeProductsSectionQuote = Object.assign(
  // Top-level PlasmicHomeProductsSectionQuote renders the root element
  makeNodeComponent("quote"),
  {
    // Helper components rendering sub-elements
    top: makeNodeComponent("top"),
    header: makeNodeComponent("header"),
    quoteLogo: makeNodeComponent("quoteLogo"),
    mercyHealthLogo: makeNodeComponent("mercyHealthLogo"),
    svg: makeNodeComponent("svg"),
    title4: makeNodeComponent("title4"),
    author: makeNodeComponent("author"),
    av: makeNodeComponent("av"),
    _name: makeNodeComponent("name"),
    button4: makeNodeComponent("button4"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicHomeProductsSectionQuote
    internalVariantProps: PlasmicHomeProductsSectionQuote__VariantProps,
    internalArgProps: PlasmicHomeProductsSectionQuote__ArgProps
  }
);

export default PlasmicHomeProductsSectionQuote;
/* prettier-ignore-end */
